<template>
  <div>
    <div v-if="loader" class="loader">
      <b-spinner
        variant="primary"
        type="grow"
        label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div>
    <highcharts v-else :options="chartOptions" ref="myChart"></highcharts>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EventBus from '../../../../../eventBus';
import api from '../../../../../services/api';

export default {
  name: 'Column',

  props: ['dataGraph'],

  data: () => ({
    chartOptions: null,
    chartTitle: '',
    plotOptions: null,
    loader: true,
    series: [],
    userAuth: null,
    colors: null,
    xAxis: null,
    grades: null,
  }),
  watch: {
    myMetric: function watchMyMetric() {
      this.changeLabel();
    },
  },
  computed: {
    ...mapState('actions', ['myActionId']),
    ...mapState('branches', ['myIh1', 'myIh2']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('authentication', ['userProfile']),
  },
  methods: {

  async setParams() {
      if (this.grades.grades) {
        if (
          this.dataGraph.metric === 'nps-1-5' ||
          this.dataGraph.metric === 'ces-1-5' ||
          this.dataGraph.metric === 'csat-1-5' ||
          this.dataGraph.metric === 'csat-1-5(media)' ||
          this.dataGraph.metric === '5-stars'
        ) {
          this.series = [
            {
              name: this.$t('reports.verticalColumn.chartSeries'),
              colorByPoint: true,
              data: [
                this.grades.grades['5'],
                this.grades.grades['4'],
                this.grades.grades['3'],
                this.grades.grades['2'],
                this.grades.grades['1'],
              ],
              cursor: 'pointer',
              point: {
                events: {
                  click: (e) => this.handleClick(e.point.category),
                },
              },
            },
          ];
          this.colors = ['#4ce595', '#4ce595', '#ecdb12', '#d62027', '#d62027'];
          this.xAxis = {
            categories: ['5', '4', '3', '2', '1'],
            visible: true,
            labels: {},
          };

          this.plotOptions = {
            column: {
              pointPadding: 0.1,
              borderWidth: 0,
              dataLabels: {
                enabled: true,
              },
            },
            series: {
              groupPadding: 0,
              pointPadding: 0.05,
              pointWidth: 55,
              borderWidth: 0,
            },
          };
        }

        if (this.dataGraph.metric === 'like-dislike') {
          this.series = [
            {
              name: this.$t('reports.verticalColumn.chartSeries'),
              colorByPoint: true,
              data: [this.grades.grades['1'], this.grades.grades['0']],
              cursor: 'pointer',
              point: {
                events: {
                  click: (e) => this.handleClick(e.point.category),
                },
              },
            },
          ];
          this.colors = ['#4ce595', '#d62027'];
          this.xAxis = {
            categories: ['1', '0'],
            visible: true,
            labels: {},
          };

          this.plotOptions = {
            column: {
              pointPadding: 0.1,
              borderWidth: 0,
              dataLabels: {
                enabled: true,
              },
            },
            series: {
              groupPadding: 0,
              pointPadding: 0.05,
              pointWidth: 55,
              borderWidth: 0,
            },
          };
        }

        if (this.dataGraph.metric === 'nps-0-10') {
          this.series = [
            {
              name: this.$t('reports.verticalColumn.chartSeries'),
              colorByPoint: true,
              data: [
                this.grades.grades['10'],
                this.grades.grades['9'],
                this.grades.grades['8'],
                this.grades.grades['7'],
                this.grades.grades['6'],
                this.grades.grades['5'],
                this.grades.grades['4'],
                this.grades.grades['3'],
                this.grades.grades['2'],
                this.grades.grades['1'],
                this.grades.grades['0'],
              ],
              cursor: 'pointer',
              point: {
                events: {
                  click: (e) =>
                    this.userProfile.permissions.answers.menu
                      ? this.handleClick(e.point.category)
                      : '',
                },
              },
            },
          ];

          this.colors = [
            '#4ce595',
            '#4ce595',
            '#ecdb12',
            '#ecdb12',
            '#d62027',
            '#d62027',
            '#d62027',
            '#d62027',
            '#d62027',
            '#d62027',
            '#d62027',
          ];

          this.xAxis = {
            categories: [
              '10',
              '9',
              '8',
              '7',
              '6',
              '5',
              '4',
              '3',
              '2',
              '1',
              '0',
            ],
            visible: true,
            labels: {},
          };

          this.plotOptions = {
            column: {
              pointPadding: 0.1,
              borderWidth: 2,
              dataLabels: {
                enabled: true,
              },
            },
            series: {
              groupPadding: 0,
              pointPadding: 0.05,
              borderWidth: 0,
            },
          };
        }
      }

    },

    async renderBars() {
      let max;

      if (this.series.length > 0) {
        max = this.series[0].data.reduce((a, b) => Math.max(a, b));

        this.chartOptions = {
          title: {
            align: 'left',
            text: '',
            style: {
              color: '#5f6368',
            },
          },
          chart: {
            type: 'column',
            height: this.dataGraph.layout.h * 38,
            spacing: [25, 20, 25, 20],
            style: {
              fontFamily:
                '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
              fontSize: '12px',
              width: '100%',
            },
          },
          xAxis: this.xAxis,
          yAxis: {
            gridLineWidth: 0,
            labels: {
              enabled: false,
            },
            max,
            title: {
              text: '',
            },
            stackLabels: {
              enabled: true,
              fontWeight: 'bold',
            },
          },
          series: this.series,
          legend: {
            enabled: false,
          },
          plotOptions: this.plotOptions,
          colors: this.colors,
        };
      }
    },
    handleClick(grade) {
      this.$router.push({ name: 'Respostas', query: { grade } });
    },
    changeLabel() {
      if (this.myMetric.indexOf('nps') !== -1) {
        this.chartTitle = this.$t('reports.verticalColumn.chartTitle');
      } else if (this.myMetric.indexOf('ces') !== -1) {
        this.chartTitle = this.$t('reports.verticalColumn.cesChartTitle');
      } else if (this.myMetric === 'csat-1-5') {
        this.chartTitle = this.$t('reports.verticalColumn.csatChartTitle');
      } else if (this.myMetric === 'csat-1-5(media)') {
        this.chartTitle = this.$t(
          'reports.verticalColumn.csatAverageChartTitle',
        );
      } else if (this.myMetric === 'csat-0-10(media)') {
        this.chartTitle = this.$t(
          'reports.verticalColumn.csat0to10AverageChartTitle',
        );
      } else if (this.myMetric === '5-stars') {
        this.chartTitle = this.$t('reports.verticalColumn.fiveStarsChartTitle');
      } else if (this.myMetric.indexOf('like-dislike') !== -1) {
        this.chartTitle = this.$t(
          'reports.verticalColumn.likeDislikeReportTitle',
        );
      }
    },

    async getData(){
      const res = await api.get(
        `${process.env.API_ROOT}/metrics-panel/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
              actionId: this.dataGraph.actionId ? this.dataGraph.actionId._id : null,
              ih1: this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
              metric: this.dataGraph.metric,
              groupId: this.dataGraph.actionGroupId ? this.dataGraph.actionGroupId._id : null,
              indicator: this.dataGraph.indicator ? this.dataGraph.indicator : null,
              indicatorValue: this.dataGraph.valueIndicator,
              period: this.dataGraph.period,
              _id: this.dataGraph._id,
            },
          },
      );

      this.grades = res.data;
    }
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
  async mounted() {
    this.loader = true;

    this.changeLabel();
    await this.getData();
    await this.setParams();
    await this.renderBars();

    if (this.series.length === 0) {
      this.loader = false;
      this.chartOptions = {
        title: {
          align: 'left',
          text: this.$t('reports.verticalColumn.chartTitle'),
          style: {
            color: '#5f6368',
          },
        },
        chart: {
          type: 'column',
          height: 350,
          spacing: [25, 20, 25, 20],
          borderRadius: 4,
          borderColor: 'rgba(0, 0, 0, 0.09)',
          borderWidth: 0.7,
          style: {
            fontFamily:
              '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
            fontSize: '12px',
            width: '100%',
          },
        },
        xAxis: {
          categories: ['10', '9', '8', '7', '6', '5', '4', '3', '2', '1', '0'],
          visible: true,
          labels: {},
        },
        yAxis: {
          gridLineWidth: 0,
          labels: {
            enabled: false,
          },
          max: 0,
          title: {
            text: '',
          },
          stackLabels: {
            enabled: true,
            fontWeight: 'bold',
          },
        },
        series: [
          {
            name: this.$t('reports.verticalColumn.chartSeries'),
            colorByPoint: true,
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
        legend: {
          enabled: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
            },
          },
          series: {
            groupPadding: 0,
            pointPadding: 0.05,
            pointWidth: 40,
            borderWidth: 0,
          },
        },
      };
    }

    this.loader = false;
  },

  beforeDestroy() {
    // EventBus.$off('change-dates');
    EventBus.$off('drawer');
    EventBus.$off('refresh');
  },
};
</script>

<style lang="scss" scoped>
.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/vertical-column/panels/grade-distribution.vue